import $ from "jquery";


document.addEventListener("DOMContentLoaded", function(){

	function showEl (el) {
		el.style.display = "block";
	}
	function hideEl (el) {
		el.style.display = "none";
	}
	function navOverlay (navToggler) {
		navToggler.addEventListener('click', function() {
			if (document.getElementById("top")) {
				let divTop = document.getElementById("top");

				if (divTop.classList.value.indexOf("page--nav-open")<0) {
					divTop.classList.add('page--nav-open');		  
				} 
				else {
					divTop.classList.remove('page--nav-open');
				}
			};
			let navPane = document.querySelector('.nav-main');
			let searchPane = document.querySelector('.nav-search');
			let socialPane = document.querySelector('.nav-socialmedia');
			if (navToggler == document.querySelector(".header__nav-toggle button")) {
				showEl(navPane);
				hideEl(searchPane);
				hideEl(socialPane);
			}
			if (navToggler == document.querySelector(".header__search-toggle button")) {
				hideEl(navPane);
				showEl(searchPane);
				hideEl(socialPane);
			}
			if (navToggler == document.querySelector(".header__social-toggle button")) {
				hideEl(navPane);
				hideEl(searchPane);
				showEl(socialPane);
			}

			if (document.getElementById("body")) {

				const body = document.getElementById("body");

				if (body.classList.value.indexOf("overflow")<0) {
					body.classList.add('overflow');
				} 
				else {
					body.classList.remove('overflow');
				}
			};
		});
	}
	navOverlay(document.querySelector(".header__nav-toggle button"));	
	navOverlay(document.querySelector(".header__search-toggle button"));	
	navOverlay(document.querySelector(".header__social-toggle button"));
	
	document.querySelector(".navigation__close button").addEventListener('click', function() {
		document.getElementById("top").classList.remove('page--nav-open');
		document.getElementById("body").classList.remove('overflow');
	});
}); 

 